import { useFormContext, Controller } from 'react-hook-form'
import { Spacer, Input } from '@cb/apricot-react'
import { formatPhoneNumber, showNumbersOnly } from '@myap/ui-library'
import { isEmpty } from 'lodash'
import { FIELD_PHONE_NUMBER, FIELD_CONFIRM_PHONE_NUMBER } from '../constants'
import { validateFieldState, validateUsNumber, validateConfirmPhoneNumber } from '../validations'

const US_PHONE_PLACEHOLDER = '(___) - ___ - ____'

const getDisplayPhoneNumber = value => {
  const normalized = showNumbersOnly(value)
  return normalized.length === 10 ? formatPhoneNumber(normalized) : normalized
}

function BfsPhoneNumber() {
  const { control, getValues } = useFormContext()

  return (
    <>
      <Controller
        control={control}
        name={FIELD_PHONE_NUMBER}
        rules={{
          required: 'Phone number is required',
          validate: value => (!isEmpty(value) ? validateUsNumber(value) : undefined),
        }}
        render={({
          field: { onChange, onBlur, value, disabled, name },
          fieldState: { invalid, isDirty, isTouched, error },
        }) => (
          <Input
            label="Provide your phone number. All fields are optional."
            name={name}
            value={getDisplayPhoneNumber(value)}
            disabled={disabled}
            required
            placeholder={US_PHONE_PLACEHOLDER}
            onChange={onChange}
            onBlur={onBlur}
            clearable={false}
            floating={false}
            autoComplete="off"
            maxLength="10"
            validation={validateFieldState({
              invalid,
              isDirty,
              isTouched,
              error,
              value,
            })}
            validationMsg={error?.message}
          />
        )}
      />
      <ul style={{ listStyleType: 'disc', paddingLeft: '40px' }}>
        <li>Sharing your mobile number is voluntary.</li>
        <li>
          Standard messaging and data rates apply. You may opt out of these text messages at any
          time. <span className="cb-icon cb-exclamation-circle" />
        </li>
        <li>Do not provide a mobile number if you&#39;re under the age of 13.</li>
        <li>Only provide a domestic/U.S. mobile phone number.</li>
        <li>Do not share a mobile number that is shared with any other student.</li>
      </ul>
      <Spacer size="24" />
      <Controller
        control={control}
        name={FIELD_CONFIRM_PHONE_NUMBER}
        rules={{
          required: 'Confirm phone number is required',
          validate: value => validateConfirmPhoneNumber(getValues(FIELD_PHONE_NUMBER))(value),
        }}
        render={({
          field: { onChange, onBlur, value, disabled, name },
          fieldState: { invalid, isDirty, isTouched, error },
        }) => (
          <Input
            label="Confirm phone number"
            name={name}
            value={getDisplayPhoneNumber(value)}
            placeholder={US_PHONE_PLACEHOLDER}
            onChange={onChange}
            onBlur={onBlur}
            clearable={false}
            floating={false}
            autoComplete="off"
            maxLength="10"
            disabled={disabled}
            required
            validation={validateFieldState({
              invalid,
              isDirty,
              isTouched,
              error,
              value,
            })}
            validationMsg={error?.message}
          />
        )}
      />
    </>
  )
}

export default BfsPhoneNumber
